import { render, staticRenderFns } from "./BoardItems.vue?vue&type=template&id=6313e0bd"
import script from "./BoardItems.vue?vue&type=script&lang=js"
export * from "./BoardItems.vue?vue&type=script&lang=js"
import style0 from "./BoardItems.vue?vue&type=style&index=0&id=6313e0bd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports